// import { LOGO_SBERBUSINESS } from '@/helpers/enums/sber';

export const BACKLOG = [
  {
    version: '0.60',
    date: '15 ноября 2021г.',
    isOpen: true,
    done: [
      'Покупатель - Добавлен список адресов пользователя;',
      'Покупатель - В оформленном заказе добавлена кнопка повторного открытия заявок в Сбер Бизнесе;',
      'Покупатель - Обновлены формулы расчета предварительной стоимости доставки;',
      'Покупатель - При оформлении заказа с автодоставкой теперь выводится предварительная стоимость всей доставки и предварительная цена доставки за тонну.',
      'Покупатель - Добавлена возможность использовать дробные значения в поле кол-ва заказа при покупке через Сбер Бизнес;',
      'Покупатель - Переработана тарировка автомобиля, улучшена обработка максимального и минимального лимита;',
      'Покупатель - Обновлено редактирование даты в календаре;',
      'Добавлена страница «Пользовательское соглашение»',
    ],
    feat: [],
  },
  {
    version: '0.50',
    date: '17 августа 2021г.',
    isOpen: false,
    done: [
      'Добавлен поиск по продуктам, заказам, странице вопрос/ответ;',
      'Добавлена сортировка по столбцам таблиц;',
      'Покупатель - Добавлена возможность покупки продукта с автодоставкой;',
      'Покупатель - В оформленном заказе теперь можно заменить/добавить водителя;',
      'Покупатель - Реализована отправка писем со статусами заказа;',
      'Покупатель - Добавлена шкала прогресса профиля;',
      'Покупатель - Контрагенты - Добавлен множественный выбор email;',
      'Продавец - Добавлен срок действия публикации;',
      'Продавец - Появилась возможность запланировать изменение цены продукта;',
      'Продавец - Реализована форма отправки заявки на добавление нового склада;',
      'Продавец - Добавлена страница со списком складов, привязанных к продавцу;',
      'Покупатель - Сбер Кредит - Реализована обработка сценария «Вам недоступна покупка в кредит»;',
      'Покупатель - Сбер Кредит - Исправлен баг с автоперезагрузкой страницы после авторизации в СББОЛ;',
      'Покупатель - На странице со списком продуктов добавлен фильтр по округу.',
    ],
    feat: [],
  },
  {
    version: '0.40',
    date: '27 мая 2021г.',
    isOpen: false,
    done: [
      'Продавец - Список заказов продукции',
      'Продавец - Детальная карточка заказа',
      'Продавец - На странице со списком заказов добавлены фильтры (по дате и по статусу заказа)',
      'Продавец - Список отгрузок',
      'Продавец - Страница Продукта - Учет кол-ва продаж (счетчик отгрузок)',
      'Покупатель - Добавлен новый способ авторизации через Sberbank Business ID',
      'Покупатель - Добавлена возможность оформлять заказы в кредит через СберБизнес',
      'Покупатель - Теперь вы можете указывать вид владения автомобилем',
      'Покупатель - В оформлении заказа улучшено поле выбора водителя',
      'Покупатель - В оформлении заказа улучшено поле выбора транспорта',
      'Добавлен новый способ авторизации через Sberbank Business ID',
      'В личном кабинете теперь можно привязывать действующие аккаунты платформы',
    ],
    feat: [],
  },
  {
    version: '0.30',
    date: '28 апреля 2021г.',
    isOpen: false,
    done: [
      'Добавлен функционал по управлению подписантами',
      'Реализовано добавление и редактирование контрагента',
      'Добавлен список должностей и оснований для полномочий',
      'Подключена реферальная система',
      'Разработан «Отчет по продажам» для продавца',
      'На главной странице добавлены Stories',
      'Оптимизация БД',
      'Продавец - Страница продажи',
      'Продавец - Список продаж',
      'Внедрена тарировка авто',
    ],
    feat: [],
  },
  {
    version: '0.20',
    date: '24 ноября 2020г.',
    isOpen: false,
    done: [
      'Запись истории входов в платформу (логи авторизаций пользователей)',
      'Публичная часть платформы',
      'Фильтр в организациях, автомобилях, транспорте',
      'Добавлен раздел «каталог» с категориями',
      'Продавец - предпросмотр оффера при создании/редактировании',
      'Возможность купить оффер через список офферов',
      'Добавлена нотификация ошибок при запросах на сервер',
      'Добавлена карта местоположения организации',
      'Добавлен чат с технической поддержкой',
      'Реалтайм в чате с технической поддержкой',
      'Запись истории изменения цен',
      'График цен для одного оффера',
      'Добавлены информационные страницы',
      'Улучшены пагинаторы',
      'Улучшено отображение системных ошибок',
      'UX/UI – проведен ряд улучшений интерфейса',
      'Реалтайм для обновления форм',
    ],
    feat: [],
  },
  {
    version: '0.12',
    date: '11 сентября 2020г.',
    isOpen: false,
    done: [
      'Калькуляция доставки',
      'Аватарка пользователя: можно добавлять/удалять/редактировать',
    ],
    feat: [],
  },
  {
    version: '0.11',
    date: '4 сентября 2020г.',
    isOpen: false,
    done: [
      'Документы к заказу',
      'Продавец - добавление товаров',
      'Возможность отменить заказ',
      'Новости',
    ],
    feat: [],
  },
];

export const getFAQData = () => {
  return [
    {
      isOpen: false,
      title: 'Что нужно, чтобы зарегистрироватся в приложении?',
      text: [
        'Вам необходимо открыть мобильное приложение «Топливо», нажать на кнопку «Зарегистрироваться» и заполнить стандартные обязательные поля: ФИО, Email, Номер телефона.',
      ],
    },
    {
      isOpen: false,
      title: 'Почему у вас самые выгодные цены на рынке?',
      text: [
        'Мы осуществляем поставки напрямую с заводов по всей стране, а в нашей безе - предложения от крупнейших российских НПЗ. Это дает нам возможность предлагать минимальные рыночные цены, а также показывать скидки, акции и специальные предложения от производителей. Так вы всегда будете в курсе актуальных оптовых цен в течение дня, чтобы в нужный момент совершить удачную сделку.',
      ],
    },
    {
      isOpen: false,
      title: 'К кому мне обратиться, если возникнут трудности с заказом?',
      text: [
        'У вас будет возможность отслеживать статус вашего заказа в приложении на любой стадии. Если возникнут трудности, вы всегда можете связаться с нашими специалистами, они оперативно помогут и ответят на любые вопросы.',
      ],
    },
    {
      isOpen: false,
      title: 'Каковы гарантии честности сделок?',
      text: [
        'Мы сотрудничаем с лучшими российскими производителями, тщательно проверяем качество продукции и контролируем процесс доставки, чтобы вы получили в кратчайший срок именно тот товар, который заказали.',
      ],
    },
    {
      isOpen: false,
      title: 'Я ни разу не приобретал топливо, у меня точно получится?',
      text: [
        'Конечно!',
        'Для оформления сделки вам необходимо выбрать заинтересовавший вас продукт, заполнить пункты «Количество», «Дата отгрузки» Введите данные контрагента. Часть информации можно получить автоматически по ИНН. Нажмите «Оформить».',
      ],
    },
  ];
};

export const REVIEWS = [
  {
    id: 1,
    author: 'Alex Luzgin',
    text: 'Хорошее приложение',
    date: '06 июня 2021',
    iconName: 'like',
  },
  {
    id: 2,
    author: 'Александр Андреев',
    text: 'Приложение огонь! Очень удобно, тёмная тема прям зачёт! 5 баллов!',
    date: '24 марта 2021',
    iconName: 'fire',
  },
  {
    id: 3,
    author: 'Callipsto59',
    text:
      'Удобный сервис для профессионалов. Актуальные цены на нефтепродукты прямо в приложении',
    date: '04 апреля 2021',
    iconName: 'smile',
  },
  {
    id: 4,
    author: 'Михаил',
    text: 'Спасибо за удобный сервис! Теперь покупаю только через вас!',
    date: '15 января 2021',
    iconName: 'fire',
  },
  {
    id: 5,
    author: 'Shirokov Nikolay',
    text: 'Отличное приложение Радует, что развиваете его и часто обновляете',
    date: '20 декабря 2020',
    iconName: 'smile',
  },
];

export const BANNERS = [
  {
    title: 'Маркетплейс нефтепродуктов',
    imageSrc: '/pages/about-mobile-app/img/ios-1.png',
    reverse: false,
    titleMargin: false,
  },
  {
    title: 'Удобный заказ - быстрое оформление заявки',
    imageSrc: '/pages/about-mobile-app/img/ios-2.png',
    reverse: false,
    titleMargin: false,
  },
  {
    title: 'Проверенные поставщики - гарантированное качество',
    imageSrc: '/pages/about-mobile-app/img/ios-3.png',
    reverse: false,
    titleMargin: false,
  },
  {
    title: 'Оптовые цены',
    imageSrc: '/pages/about-mobile-app/img/ios-4.png',
    reverse: false,
    titleMargin: false,
  },
  // {
  //   title: 'Более 200+<br/> <span class="sm-text">выгодных предложений</span>',
  //   imageSrc: '/pages/about-mobile-app/img/ios-5.png',
  //   reverse: true,
  //   titleMargin: false,
  // },
  // {
  //   title: 'Скачай и начинай<br/> покупать уже<br/> сейчас',
  //   imageSrc: '/pages/about-mobile-app/img/ios-6.png',
  //   reverse: false,
  //   titleMargin: true,
  // },
];

export const PAYMENTFUTURES = [
  {
    id: 1,
    iconName: 'phone-in-hand',
    text: 'Заказывать нефтепродукты и управлять заказами',
    wowClass: 'fadeInLeftBig',
  },
  {
    id: 2,
    iconName: 'phone-prices',
    text: 'Следить за актуальными оптовыми ценами на все виды нефтепродуктов',
    wowClass: 'fadeIn',
  },
  {
    id: 3,
    iconName: 'phone-news',
    text: 'Следить за новостями и акциями',
    wowClass: 'fadeInRightBig',
  },
];

export const SOCIALS = [
  {
    link: 'https://t.me/open_oil_market',
    icon: 'tg',
  },
  {
    link: 'https://vk.com/openoilmarket',
    icon: 'vk',
  },
  {
    link: 'https://dzen.ru/openoilmarket',
    icon: 'dzen',
  },
  {
    link: 'https://youtube.com/@openoilmarket',
    icon: 'youtube',
  },
];

export const getAboutCreditsData = () => {
  return [
    // {
    //   logo: LOGO_SBERBUSINESS,
    //   name: 'Sberbank',
    //   isOpen: false,
    //   description:
    //     'Подробнее ознакомиться с условиями кредитования вы можете на сайте СберБизнес',
    //   link:
    //     'https://www.sberbank.ru/businesscredit/partner/info?id=org-market&site=https://org-market.com/',
    //   linkText: 'Ознакомиться Подробнее',
    //   pdf: '',
    //   headerItems: [
    //     {
    //       value: '5 000 000Р',
    //       description: 'сумма кредита',
    //     },
    //     {
    //       value: '2,5% за месяц',
    //       description: '30% годовых',
    //     },
    //     {
    //       value: 'до 12 месяцев',
    //       description: 'срок кредита',
    //     },
    //   ],
    //   contentItems: [
    //     {
    //       title:
    //         'Авторизуйтесь<br> на платформе OPEN OIL MARKET по СберБизнес ID',
    //       icon: 'Bank_Instruction_1',
    //     },
    //     {
    //       title: 'Выберите<br> продукт и заполните форму заказа',
    //       icon: 'Bank_Instruction_2',
    //     },
    //     {
    //       title: 'Подайте заявку<br> на кредит',
    //       icon: 'Bank_Instruction_3',
    //     },
    //     {
    //       title:
    //         'В новой вкладке браузера<br> банк рассмотрит заявку от 3-х мин',
    //       icon: 'Bank_Instruction_4',
    //     },
    //     {
    //       title: 'Получите<br> одобрение',
    //       icon: 'Bank_Instruction_5',
    //     },
    //     {
    //       title: 'Подпишите<br> договор электронно',
    //       icon: 'Bank_Instruction_6',
    //     },
    //     {
    //       title: 'Подтвердите<br> оплату',
    //       icon: 'Bank_Instruction_7',
    //     },
    //     {
    //       title: 'Получите<br> ваш заказ',
    //       icon: 'Bank_Instruction_8',
    //     },
    //   ],
    // },
    {
      logo: '/static/images/logos/alfa-additional.svg',
      name: 'Alfa Bank Additional',
      isAlfaAdditional: true,
      isOpen: false,
      description:
        'Рассрочка на закупку топлива и нефтепродуктов для клиентов Альфа-Банка',
      link: 'https://kurl.ru/kqYXF',
      linkText: 'Ознакомиться Подробнее',
      headerItems: [
        {
          value: 'до 1 000 000Р',
          description: 'сумма кредита',
        },
        {
          value: 'от 2% в месяц',
          description: 'процентная ставка',
        },
        {
          value: '4 месяца',
          description: 'срок кредита',
        },
      ],
      contentItems: [
        {
          title: 'Выберите «Купить в рассрочку» в форме заказа',
          icon: 'Bank_Instruction_2',
        },
        {
          title: 'Авторизуйтесь на сайте Альфа-Банка',
          icon: 'Bank_Instruction_3',
        },
        {
          title: 'Подпишите оферту и получите деньги',
          icon: 'Bank_Instruction_8',
        },
      ],
    },
    {
      logo: '/static/images/logos/Alfa_Bank_Logo.svg',
      name: 'Alfa Bank',
      isOpen: false,
      description: 'Бизнес-кредит для финансирования текущей деятельности',
      link:
        'https://alfabank.ru/sme/profits/partners/short/?pin=bb820801-9f4f-451f-9bd8-eb0b02f0d169&platformId=openmarcred_businesscredit_alliances_lk&utm_source=openmarcred_lk&utm_medium=refer&utm_campaign=openmarcred_businesscredit_alliances_lk',
      linkText: 'Ознакомиться Подробнее',
      headerItems: [
        {
          value: 'до 150 000 000Р',
          description: 'сумма кредита',
        },
        {
          value: 'индивидуальный расчет',
          description: 'процентная ставка',
        },
        {
          value: 'до 10 лет',
          description: 'срок кредита',
        },
      ],
      contentItems: [
        {
          title: 'Заполните заявку онлайн<br> в кабинете Альфа-Банка',
          icon: 'Bank_Instruction_2',
        },
        {
          title: 'Предоставьте<br> документы',
          icon: 'Bank_Instruction_3',
        },
        {
          title: 'Получите<br> деньги',
          icon: 'Bank_Instruction_5',
        },
      ],
    },

    {
      logo: '/static/images/logos/t-bank.svg',
      name: 'Tinkoff',
      isOpen: false,
      description:
        'Подробнее ознакомиться с условиями кредитования вы можете на сайте «Т-Банк»',
      link:
        'https://www.tbank.ru/business/turnover/form?utm_medium=ptr.act&utm_campaign=sme.partners&partnerId=5-3I17IDI6V&agentId=5-1Y3C00DW5&agentSsoId=faa5b914-f33b-4adc-9186-50c60f09e053&utm_source=partner_rko_a_sme',
      linkText: 'Ознакомиться Подробнее',
      // pdf: 'ОГР_Маркет_Сбер_Кредит_Инструкция.pdf',
      headerItems: [
        {
          value: 'до 10 000 000Р',
          description: 'сумма кредита',
        },
        {
          value: 'индивидуальный расчет',
          description: 'процентная ставка',
        },
        {
          value: 'от 1 до 6 месяцев',
          description: 'срок кредита',
        },
      ],
      contentItems: [
        {
          title: 'Введите номер телефона',
          icon: 'Bank_Instruction_2',
        },

        {
          title:
            'Загрузите выписку из вашего банка и получите предварительное решение',
          icon: 'Bank_Instruction_4',
        },

        {
          title: 'Получите деньги на счет в «Т-Банк»',
          icon: 'Bank_Instruction_8',
        },
      ],
    },
    {
      logo: '/static/images/logos/logo_smartfact.png',
      name: 'Alfa Bank',
      isOpen: false,
      description: 'Бизнес-кредит для финансирования текущей деятельности',
      link:
        'https://lk.smfox.ru/login?source=smfact&utm_source=partners&utm_medium=referal&utm_campaign=open_oil_market',
      linkText: 'Ознакомиться Подробнее',
      headerItems: [
        {
          value: 'до 100 000 000Р',
          description: 'лимит',
        },
        {
          value: 'индивидуальный расчет',
          description: 'процентная ставка',
        },
        {
          value: 'от 1 до 12 месяцев',
          description: 'срок',
        },
      ],
      contentItems: [
        {
          title:
            'Зарегистрируйтесь и подайте заявку онлайн на лимит в личном кабинете СмартФакт',
          icon: 'Bank_Instruction_2',
        },
        {
          title: 'Предоставьте минимум документов',
          icon: 'Bank_Instruction_3',
        },
        {
          title: 'Получите деньги на номинальный счет OPEN OIL MARKET',
          icon: 'Bank_Instruction_5',
        },
      ],
    },
    // {
    //   logo: '/static/images/logos/Papa_Finance.png',
    //   name: 'Papa Finance',
    //   isOpen: false,
    //   description:
    //     'Вы можете получить деньги на покупку нефтепродуктов у нашего партнера – Папа Финанс!',
    //   link:
    //     'https://papafinance.ru/oilresurs/?utm_source=oilresurs&utm_medium=email',
    //   linkText: 'Подать заявку',
    //   headerItems: [
    //     {
    //       value: 'до 10 000 000Р',
    //       description: 'сумма финансирования',
    //     },
    //     {
    //       value: 'от 0,15% в день',
    //       description: 'ставка от 0,15% до 0,2% в день',
    //     },
    //     {
    //       value: 'на 6 месяцев',
    //       description: 'срок кредита',
    //     },
    //   ],
    //   contentItems: [
    //     {
    //       title: 'Всего 3 документа<br> для установления лимита',
    //       icon: 'Bank_Instruction_3',
    //     },
    //     {
    //       title: 'Выдача средств<br> на следующий день после решения',
    //       icon: 'Bank_Instruction_8',
    //     },
    //     {
    //       title: 'Решение о выдаче<br> принимается за 24 часа',
    //       icon: 'Bank_Instruction_6',
    //     },
    //   ],
    // },
  ];
};
